import React, { FC } from 'react';
import Box from '@mui/material/Box';
import PoweredByLogo from 'src/assets/logo/logo_poweredby_attune.svg';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { pathOr } from 'ramda';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { Theme } from '@mui/material/styles/createTheme';
import SiteSettings from 'src/siteSetting';
import { isNotEmpty } from 'src/utilities/hasValue';
interface FooterProps {
  hasBorderTop?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    footer: {
      position: 'fixed',
      bottom: '0px',
      marginBottom: '0px',
      width: '100%',
      backgroundColor: pathOr('#fff', ['palette', 'basic', 'white'], theme),
      [theme.breakpoints.down('sm')]: {
        left: '5px',
        right: '0px',
        borderTop: `1px solid #a8b2bd`,
      },
    },
  })
);

const Footer: FC<FooterProps> = ({ hasBorderTop }) => {
  const classes = useStyles();

  return (
    <Box
      p={1}
      className={classes.footer}
      sx={{
        borderTop: hasBorderTop ? '1px solid #E7E6E9' : '',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Box gap={1} style={{ display: 'flex', alignItems: 'center', }}>
        {isNotEmpty(SiteSettings.generalNMLS()) && (
          <Typography fontSize={'12px'}>
            {SiteSettings.generalNMLS()}
          </Typography>
        )}
      </Box>
      <Link href="https://getattune.com/" target="_blank">
        <PoweredByLogo />
      </Link>
    </Box>
  );
};

export default Footer;
